import { supabase } from '@/lib/supabase';
import { useEffect, useRef, useState } from 'react';

interface FlushState {
  flushedSec: number;
  writing: boolean;
}

/**
 * Creates an activity
 */
export function trackPlaytime(contentId: string | null, userId: string | null) {
  const [durSec, setDurSec] = useState<number>(0);
  const [activityId, setActivityId] = useState<string | null>(null);

  const flushed = useRef<FlushState>({
    flushedSec: 0,
    writing: false,
  });

  // reset
  useEffect(() => {
    if (contentId && userId) {
      console.log('resetting activity tracking');
      flushed.current = {
        flushedSec: 0,
        writing: false,
      };
      setActivityId(null);

      setDurSec(0);
    }
  }, [contentId, userId]);

  // Create an activity record on first usage for this content/user
  useEffect(() => {
    // console.log(
    //   `in effect, durSec=${durSec}, contentId=${contentId}}, userId=${userId}`,
    // );
    if (!userId || !contentId) return;
    if (flushed.current.writing) return; // poor mans debounce 🙏

    const delta = durSec - flushed.current.flushedSec;
    if (delta <= 5) return; // not signficant enought yet

    if (!activityId) {
      const createActivity = async () => {
        flushed.current.writing = true;
        try {
          const { data, error } = await supabase
            .from('activity')
            .insert({
              user_id: userId,
              content_id: contentId,
              dur_sec: 0,
            })
            .select('id')
            .single();
          if (error || !data) {
            console.error('Failed to create activity:', error);
            return;
          }
          console.log('created activity ', data?.id);
          setActivityId(data.id);
        } finally {
          flushed.current.writing = false;
        }
      };

      createActivity();
      return;
    }

    let canceled = false;
    const updateDuration = async () => {
      flushed.current.writing = true;
      try {
        const { error } = await supabase
          .from('activity')
          .update({
            dur_sec: Math.round(durSec),
            updated_at: new Date().toISOString(),
          })
          .eq('id', activityId);

        if (error) {
          console.error('Failed to update activity duration:', error);
        }
        // activityId can change during API call
        if (!canceled) flushed.current.flushedSec = durSec;
      } finally {
        flushed.current.writing = false;
      }

      console.log(`updated dur to ${Math.round(durSec)}, ${activityId}`);
    };

    updateDuration();
    return () => {
      canceled = true;
    };
  }, [userId, contentId, activityId, durSec]);

  return [setDurSec];
}
